import React, { useMemo } from "react";

import BottomSheet from "../common/BottomSheet";
import Fade from "@material-ui/core/Fade";

import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Box } from "@material-ui/core";
import DevelopmentsList from "./DevelopmentsList";

import uniqBy from "lodash.uniqby";

export default React.memo(
  function DevelopmentsInfo({
    activeFeatures,
    selectedId,
    setSelectedId,
    flyTo,
    filters
  }) {
    const { breakpoints } = useTheme();
    const isLarge = useMediaQuery(breakpoints.up("md"));

    const hasActiveFeatures = activeFeatures !== undefined;
    const developments = useMemo(
      () => activeFeatures
          ? uniqBy(
              activeFeatures.features.filter(feature => {
                for (let i = 0; i < filters.length; i++) {
                  const filter = filters[i];
                  if (filter.key === "status") {
                    // check if the filter includes the status
                    return filter.value.includes(feature.properties.status);
                  } else {
                    // otherwise check if the feature has the property,
                    // i.e. feature.properties['residential']
                    return feature.properties[filter.key];
                  }
                }
                return true;
              }),
              "properties.permit_id"
            )
          : [],
      [activeFeatures, filters]
    );

    return (
      <>
        {isLarge ? (
          <Fade in={isLarge && hasActiveFeatures}>
            <Box
              position="absolute"
              zIndex={{ xs: 60, md: 40 }}
              top={0}
              left={0}
              bottom={0}
              width={{ xs: 0, md: 412 }}
              bgcolor="#fff"
              boxShadow={{ xs: 0, md: 2 }}
            >
              <DevelopmentsList
                developments={developments}
                selectedId={selectedId}
                setSelectedId={setSelectedId}
                flyTo={flyTo}
              />
            </Box>
          </Fade>
        ) : (
          <BottomSheet
            overflowHeight={120}
            visible={!isLarge && hasActiveFeatures}
            zIndex={isLarge ? 30 : 60}
          >
            <DevelopmentsList
              developments={developments}
              selectedId={selectedId}
              setSelectedId={setSelectedId}
              flyTo={flyTo}
            />
          </BottomSheet>
        )}
      </>
    );
  },
  (prevProps, nextProps) =>
    prevProps.selectedId === nextProps.selectedId &&
    JSON.stringify(prevProps.activeFeatures) ===
      JSON.stringify(nextProps.activeFeatures)
);
